import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import UsersDomain from "domainActions/users/UsersDomain";
import usePermissions from "hooks/usePermissions";
import PaginatedSelect from "../common/Select/PaginatedSelect";
const formatUsers = (users) => users.map((user) => ({ label: `${user.username} (${user.fullName})`, value: user.username }));
const UsersSelectField = ({ value, onChange }) => {
  const { t } = useTranslation("users");
  const { isPermitted } = usePermissions();
  const loadUsers = useCallback(
    (pagination) => {
      if (!isPermitted("users:list")) {
        return Promise.resolve({
          pagination,
          total: 0,
          list: []
        });
      }
      return UsersDomain.loadUsersPaginated(pagination).then((results) => ({
        total: results.pagination.total,
        list: formatUsers(results.list.toArray()),
        pagination
      }));
    },
    [isPermitted]
  );
  return /* @__PURE__ */ React.createElement(
    PaginatedSelect,
    {
      id: "user-select-list",
      value,
      placeholder: t("users_list.select_users"),
      onLoadOptions: loadUsers,
      multi: true,
      onChange
    }
  );
};
export default UsersSelectField;
